import ContentContainer from '@fragments/Setting/ContentContainer';
import Device from '@fragments/Setting/Device';
import SettingCheckModal from '@fragments/Setting/Modal';
import { useGetPath } from '@hooks/interview/useGetPath';
import { useMeetingManager } from '@providers/MeetingProvider';
import { interviewTime } from '@stores/atoms/time';
import { isSpeakerChecked } from '@stores/selectors/device';
import { useAtomValue, useSetAtom } from 'jotai';
import type { FC } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { EnterButton } from './style';

const Content: FC = () => {
  const deviceCheck = useAtomValue(isSpeakerChecked);
  const { rootPath } = useGetPath();
  const navigation = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const meetingManager = useMeetingManager();
  const setInterviewTime = useSetAtom(interviewTime);
  const date = new Date();

  const timerAnimationFrame = () => {
    const padZero = (num: number) => (num < 10 ? `0${num}` : num.toString());

    const step = () => {
      const now = new Date();
      const elapsed = now.getTime() - date.getTime();
      const timer = new Date(elapsed);

      const hh = padZero(timer.getUTCHours());
      const mm = padZero(timer.getUTCMinutes());
      const ss = padZero(timer.getUTCSeconds());

      setInterviewTime(`${hh}:${mm}:${ss}`);
      window.requestAnimationFrame(step);
    };

    window.requestAnimationFrame(step);
  };

  const handleClickConfirm = async () => {
    if (!deviceCheck) return setOpenModal(true);

    await meetingManager.start();
    timerAnimationFrame();
    navigation(rootPath.WAITING);
  };

  const handleClickModalCancel = () => {
    setOpenModal(false);
  };

  const handleClickModalConfirm = () => {
    navigation(rootPath.WAITING);
  };

  return (
    <ContentContainer>
      <Device />
      <EnterButton onClick={handleClickConfirm} disabled={!deviceCheck}>
        환경 설정 완료
      </EnterButton>
      <SettingCheckModal
        onClickConfirm={handleClickModalConfirm}
        onClickCancel={handleClickModalCancel}
        open={openModal}
      />
    </ContentContainer>
  );
};

export default Content;
